import { useIntl } from "react-intl";

import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type DeleteCanceledOrderConfirmationModalProps = Pick<
  YesNoModalProps,
  "onClickYes" | "onClickNo"
>;

export function DeleteCanceledOrderConfirmationModal({
  onClickYes,
  onClickNo,
}: DeleteCanceledOrderConfirmationModalProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.delete-canceled-order-confirmation-modal.title",
      })}
      body={intl.formatMessage({
        id: "components.delete-canceled-order-confirmation-modal.body",
      })}
      yesLabel={intl.formatMessage({
        id: "generic.actions.delete-list",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.cancel",
      })}
      isGrey
    />
  );
}
